export default __webpack_public_path__ + "static/collect-cards-280ee8dde07b92a594b416fdcb21256e.png";